export enum RetailFeature {
  WORKSHOP_CUSTOMER_STATUS = 'WORKSHOP_CUSTOMER_STATUS',
}
